import {
    useCallback, useEffect, useMemo, useState,
} from 'react';
import { useNavigate } from 'react-router-dom';
import { generateDFSClientId } from 'utils';
import { useChangePlan } from '../context';
import { AdditionalData, InvestorProfileHook } from './InvestorProfileHooks.types';

export const useInvestorProfileChangePlan = (): InvestorProfileHook => {
    const navigate = useNavigate();
    const [jaUsers, setJaUsers] = useState<Array<any>>([]);
    const {
        riskProfile: { setData: setRiskProfile },
        productDescription,
        mainOwnerDetails,
        isJointAccount,
        isThreeBProduct,
        portfolioOwners,
    } = useChangePlan();

    const clientName = mainOwnerDetails?.clientName;
    const clientAge = mainOwnerDetails?.clientAge;

    const mainOwnerId = useMemo(() => mainOwnerDetails?.clientId, [mainOwnerDetails]);

    const saveAdditionalData = useCallback(async ({ response, answers }: AdditionalData) => {
        setRiskProfile({
            recommendedStrategy: response,
            answers,
        });
    }, []);

    const onBack = useCallback(() => navigate(-1), [navigate]);

    useEffect(() => {
        const users = portfolioOwners?.map(item => ({
            id: item.id,
            name: item.name,
            dfsClientId: generateDFSClientId(item.id),
            isValid: true,
        }));

        setJaUsers(users);
    }, [portfolioOwners]);

    return {
        clientAge,
        clientName,
        saveAdditionalData,
        onBack,
        productDescription,
        isJointAccount,
        isThreeB: isThreeBProduct,
        jaUsers,
        setJaUsers,
        mainOwnerId,
        targetDFSClientId: generateDFSClientId(mainOwnerId),
        targetClientName: portfolioOwners.find(owner => owner.id === mainOwnerId)?.name,
        childClientName: portfolioOwners.find(owner => owner.id !== mainOwnerId)?.name,
    };
};
